import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "firstField", "referenceSearch", "saveButton", "approveButton"]

  connect() {
    if (!this.hasFirstFieldTarget) return
    if (document.activeElement && document.activeElement !== document.body) return

    requestAnimationFrame(() => this.firstFieldTarget.focus())
  }

  handleKeydown(event) {
    if (this.focusReferenceSearch(event)) return
    if (this.submitApproveShortcut(event)) return
    if (this.submitSaveShortcut(event)) return
    if (this.preventImplicitSubmit(event)) return
  }

  focusReferenceSearch(event) {
    if (!this.hasReferenceSearchTarget) return false
    if (event.key !== "/" || event.metaKey || event.ctrlKey || event.altKey) return false
    if (this.editableTarget(event.target)) return false

    event.preventDefault()
    this.referenceSearchTarget.focus()
    this.referenceSearchTarget.select()
    return true
  }

  submitSaveShortcut(event) {
    if (!((event.metaKey || event.ctrlKey) && !event.shiftKey && event.key.toLowerCase() === "s")) return false
    if (!(this.hasFormTarget && this.hasSaveButtonTarget)) return false

    event.preventDefault()
    this.formTarget.requestSubmit(this.saveButtonTarget)
    return true
  }

  submitApproveShortcut(event) {
    if (!((event.metaKey || event.ctrlKey) && event.key === "Enter")) return false
    if (!(this.hasFormTarget && this.hasApproveButtonTarget)) return false

    event.preventDefault()
    this.formTarget.requestSubmit(this.approveButtonTarget)
    return true
  }

  preventImplicitSubmit(event) {
    if (event.key !== "Enter") return false
    if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return false
    if (!(event.target instanceof HTMLElement)) return false

    const tagName = event.target.tagName
    if (tagName !== "INPUT") return false

    const inputType = (event.target.getAttribute("type") || "text").toLowerCase()
    if (["submit", "button", "checkbox", "radio", "file", "color", "range", "date", "time", "datetime-local"].includes(inputType)) return false

    event.preventDefault()
    return true
  }

  editableTarget(target) {
    if (!(target instanceof HTMLElement)) return false
    if (target.isContentEditable) return true

    return ["INPUT", "TEXTAREA", "SELECT"].includes(target.tagName)
  }
}
